// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2715":"b8a11a98cbb6bfb5","3942":"4e044958f938eaa0","4213":"c8ae9df65580a992","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};